import React from 'react';

import { Option } from './types';
import { InputItem } from './Select.styled';

export interface ComponentProps {
  option: Option;
  mode?: 'primary' | 'secondary';
  style?: React.CSSProperties;
  handleInputItemClick: () => Promise<void>;
  truncateChars?: number;
}

const OptionInputItem: React.FC<ComponentProps> = ({ option, style, handleInputItemClick, truncateChars, mode }) => {
  const truncate = (value: string): string =>
    truncateChars && value && value.length > truncateChars ? `${value.substring(0, truncateChars)}...` : value;

  return (
    <InputItem mode={mode} style={style} onClick={handleInputItemClick}>
      {option.selectedRender !== undefined && option.selectedRender}
      {option.selectedRender === undefined && option.selectedLabel !== undefined && option.selectedLabel}
      {option.selectedRender === undefined && option.selectedLabel === undefined && truncate(option.label)}
    </InputItem>
  );
};

export default OptionInputItem;
